import React from 'react';
import { Avatar, Box, ContentTemplate, KeyValue, SectionHeader } from 'web-library';
import { UserGroupDetail } from 'web-library/models/UserGroupAccessConfiguration/UserGroupAccessConfiguration';
import { useTranslation } from 'react-i18next';


import { makeStyles } from 'tss-react/mui';
import FormHeader from '../../../../components/form-items/FormHeader';
import ViewAdminAccountDataTable from '../../../../pages/userGroupAccessConfiguration/CreateEditViewUserGroup/ViewAdminAccountDataTable';

const useStyles = makeStyles()((theme) =>
({
  formHeaderContainer: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  pill: {
    marginTop: theme.spacing(0.5),
    background: theme.color.pill.pillInfoBg,
    color: theme.color.pill.pillInfoText,
    border: 'none',
    '& .MuiTypography-root': {
      color: theme.color.pill.pillInfoText,
    },
  },
  adminAccountHeaderContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: theme.spacing(-2),
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(-1),
    },
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
    },
  },
}));

interface UserGroupTaskDetailsProps {
  userGroupDetail: UserGroupDetail;
}

const UserGroupTaskDetails = ({ userGroupDetail }: UserGroupTaskDetailsProps) => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  return (
    <>
      <ContentTemplate isDividerBottom isContinuable>
        <SectionHeader title={t('admin->>UserGroups.UserGroupDetails')} />
        <KeyValue
          keyText={t('admin->>UserGroups.UserGroupName')}
          valueText={userGroupDetail.userGroupDisplayName}
        />
      </ContentTemplate>
      <ContentTemplate type="full" isContinuable continuous>
        <Box className={classes.adminAccountHeaderContainer}>
          <Box className={classes.formHeaderContainer}>
            <FormHeader title={t('admin->>UserGroups.AdminAccounts')} />
            <Avatar className={classes.pill} type="text">
              {userGroupDetail.userAccounts?.length || 0}
            </Avatar>
          </Box>
        </Box>
        <ViewAdminAccountDataTable userGroupDetails={userGroupDetail} />
      </ContentTemplate>
    </>
  );
};

export default UserGroupTaskDetails;
